interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  isLoading?: boolean;
  label?: string;
  name?: string;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  disabled = false,
  isLoading = false,
  label,
  name
}) => {
  return (
    <div className="flex items-center gap-2">
      {label && <span className="text-sm text-gray-600">{label}</span>}
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        name={name}
        disabled={disabled || isLoading}
        onClick={() => !disabled && !isLoading && onChange(!checked)}
        className={`
                    relative inline-flex h-6 w-11 items-center rounded-full transition-colors
                    ${checked ? 'bg-green-600' : 'bg-gray-300'}
                    ${(disabled || isLoading) ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}
                `}
      >
        <span
          className={`
                        inline-block h-4 w-4 transform rounded-full bg-white transition-transform
                        ${checked ? 'translate-x-6' : 'translate-x-1'}
                        ${isLoading ? 'animate-pulse' : ''}
                    `}
        />
      </button>
      {isLoading && (
        <div className="h-4 w-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
      )}
    </div>
  );
};

export default ToggleSwitch;